import React from "react";
import * as agent from "../agent";
import renderHTML from 'react-render-html';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

class Bankrupt extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bankruptInfoStatus: "INACTIVE",
            bankruptInfo: "",
            bankruptError: ""
        };
    }
    onRequireBankupt = (e) => {
        e.preventDefault();
        this.setState({ bankruptInfoStatus: "LOADING" });
        const { firstname, lastname } = this.props;
        agent.Clients.bankruptRequset({ firstname, lastname })
            .then(res => {
                this.setState({ bankruptInfo: res.linksReplacedTable, bankruptInfoStatus: "SUCCESS"})
            })
            .catch(e => this.setState({ bankruptInfoStatus: "REJECTED", bankruptInfo: "", bankruptError: e.message }))
    }

    render() {
        const { bankruptInfo, bankruptInfoStatus, bankruptError } = this.state;
        const { firstname, lastname } = this.props;
        return (
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={16}>
            { ({
                "INACTIVE": (<Grid item ><Typography paragraph >Проверка не проводилась</Typography></Grid>),
                "LOADING": (<Grid item >
                                <Typography paragraph >Поиск информации. Ожидайте...</Typography>
                                <CircularProgress />
                            </Grid>),
                "SUCCESS": (<Grid item >
                                <Typography paragraph >Результат поиска по запросу '{lastname} {firstname}'</Typography>
                                { bankruptInfo && renderHTML(bankruptInfo) }
                            </Grid>),
                "REJECTED":  (<Grid item ><Typography paragraph >Возникла ошибка: {bankruptError}</Typography></Grid>)
            })[bankruptInfoStatus] }
                <Grid item>
                    <Button type="submit"
                            onClick={this.onRequireBankupt}
                            disabled={firstname.length === 0 || lastname.length === 0}
                            size="large"
                            color="primary"
                            variant="contained"> Запрос информации </Button>
                </Grid>
            </Grid>
        )
    }
}

export default Bankrupt;



// WEBPACK FOOTER //
// ./src/components/Bankrupt.js